import { createFeatureSelector, createSelector } from '@ngrx/store';
import { DASHBOARD_FEATURE_KEY, DashboardState, dashboardAdapter } from './dashboard.reducer';

// Lookup the 'Dashboard' feature state managed by NgRx
export const getDashboardState = createFeatureSelector<DashboardState>(DASHBOARD_FEATURE_KEY);

const { selectAll, selectEntities } = dashboardAdapter.getSelectors();

export const GetUserDashboardData = createSelector(
  getDashboardState,
  (state: DashboardState) => state.userDashboardData
);
